namespace Gamification.Gamification {
    export interface ExtendedStandardRequest extends Serenity.ServiceRequest {
        IdUtente?: number;
        Token?: string;
        Email?: string;
    }
}
